import React from "react";

import Editor from './BTagsTitleEditor'
import EditorWrapper from '../../EditorWrapper'

import TagsTitle from "../../common/TagsTitle";
import EmptyArticle from "../../common/EmptyArticle";

const BTagsTitle = props => {
    let article = EmptyArticle();
    const { settings } = props;

    article.title = settings.title;

    return (
        <div>
            <div className={props.classes} {...props.events} >
                <EditorWrapper {...props} editor={Editor} />
                <TagsTitle
                    article={article}
                    {...props}
                />
            </div>
        </div>
    );
};


export default BTagsTitle;
